/* GNJ Advertorial — click-to-play video (no autoplay), idempotent across duplicate includes */
(function () {
  if (window.__gnjAdvInit) return;
  window.__gnjAdvInit = true;

  function init() {
    document.querySelectorAll('[data-ga-video]').forEach(function (wrap) {
      var btn = wrap.querySelector('.ga-video__poster');
      var video = wrap.querySelector('video');
      if (!btn || !video) return;
      video.setAttribute('preload', 'metadata');
      video.setAttribute('playsinline', '');
      video.removeAttribute('autoplay');
      btn.addEventListener('click', function () {
        btn.classList.add('is-hidden');
        btn.setAttribute('aria-hidden', 'true');
        btn.tabIndex = -1;
        if (wrap.dataset.gaMuted === 'true') video.muted = true;
        video.setAttribute('controls', '');
        var p = video.play();
        if (p && p.catch) p.catch(function () { /* user gesture edge case: controls are visible */ });
        video.focus();
      });
      /* pause when scrolled far out of view to save battery */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting && !video.paused) video.pause();
          });
        }, { threshold: 0.05 }).observe(wrap);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
